var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.462,
    height: 39.333,
    viewBox: "0 0 27.462 39.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b3e59f;}.b{fill:#95d6a4;}.c{fill:#f6f9f9;}.d{fill:#dae4ea;}.e{fill:#617881;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.011,2.277l-2.219,2.453-22.16-.543-1.4-1.91L89.607.33A.778.778,0,0,1,90.243,0H112a.778.778,0,0,1,.636.33Z",
    transform: "translate(-87.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.234.33A.778.778,0,0,0,375.6,0h-1.832a.778.778,0,0,1,.636.33l1.373,1.948.646,1.549,1.187-1.549Z",
    transform: "translate(-350.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M104.469,66.7H77.521a.257.257,0,0,1-.257-.257V29.9a.257.257,0,0,1,.257-.257h26.948a.257.257,0,0,1,.257.257V66.445A.257.257,0,0,1,104.469,66.7Z",
    transform: "translate(-77.265 -27.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M412.412,29.646h-1.579a.257.257,0,0,1,.257.257V66.445a.257.257,0,0,1-.257.257h1.579a.257.257,0,0,0,.257-.257V29.9a.257.257,0,0,0-.257-.257Z",
    transform: "translate(-385.208 -27.369)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.496 10.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.066,152.993h-4.026a.256.256,0,0,1-.256-.256v-4.026a.256.256,0,0,1,.256-.256h4.026a.256.256,0,0,1,.256.256v4.026A.256.256,0,0,1,127.066,152.993Z",
    transform: "translate(-122.785 -147.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.568,148.457h-1.327a.256.256,0,0,1,.256.256v4.026a.256.256,0,0,1-.256.256h1.327a.256.256,0,0,0,.256-.256v-4.026A.256.256,0,0,0,162.568,148.457Z",
    transform: "translate(-158.287 -147.168)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M141.92,136.543a.594.594,0,0,1-.42-.174l-1.173-1.173a.594.594,0,0,1,.84-.839l.753.753,3.254-3.254a.594.594,0,1,1,.84.839l-3.674,3.674A.594.594,0,0,1,141.92,136.543Z",
    transform: "translate(-140.153 -131.682)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.253 1.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M223.75,156.436h-5.963a.594.594,0,1,1,0-1.187h5.963a.594.594,0,1,1,0,1.187Z",
    transform: "translate(-217.193 -155.249)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M230.408,186.461H217.787a.594.594,0,1,1,0-1.187h12.622a.594.594,0,0,1,0,1.187Z",
    transform: "translate(-217.193 -185.274)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.496 18.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.066,267.975h-4.026a.256.256,0,0,1-.256-.256v-4.026a.256.256,0,0,1,.256-.256h4.026a.256.256,0,0,1,.256.256v4.026A.256.256,0,0,1,127.066,267.975Z",
    transform: "translate(-122.785 -262.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.568,263.439h-1.327a.256.256,0,0,1,.256.256v4.026a.256.256,0,0,1-.256.256h1.327a.256.256,0,0,0,.256-.256v-4.026A.256.256,0,0,0,162.568,263.439Z",
    transform: "translate(-158.287 -262.15)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M141.92,251.525a.592.592,0,0,1-.42-.174l-1.173-1.173a.594.594,0,1,1,.839-.84l.753.753,3.254-3.254a.594.594,0,1,1,.84.839l-3.674,3.673A.592.592,0,0,1,141.92,251.525Z",
    transform: "translate(-140.153 -246.664)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.253 1.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M223.75,271.417h-5.963a.594.594,0,0,1,0-1.187h5.963a.594.594,0,1,1,0,1.187Z",
    transform: "translate(-217.193 -270.23)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M230.408,301.443H217.787a.594.594,0,1,1,0-1.187h12.622a.594.594,0,0,1,0,1.187Z",
    transform: "translate(-217.193 -300.256)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.496 27.783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.066,382.957h-4.026a.256.256,0,0,1-.256-.256v-4.026a.256.256,0,0,1,.256-.256h4.026a.256.256,0,0,1,.256.256V382.7A.256.256,0,0,1,127.066,382.957Z",
    transform: "translate(-122.785 -377.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.568,378.421h-1.327a.256.256,0,0,1,.256.256V382.7a.256.256,0,0,1-.256.256h1.327a.256.256,0,0,0,.256-.256v-4.026A.256.256,0,0,0,162.568,378.421Z",
    transform: "translate(-158.287 -377.132)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M141.92,366.508a.594.594,0,0,1-.42-.174l-1.173-1.173a.594.594,0,0,1,.84-.84l.753.753,3.254-3.254a.594.594,0,1,1,.84.84l-3.674,3.674A.594.594,0,0,1,141.92,366.508Z",
    transform: "translate(-140.153 -361.647)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.253 1.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M223.75,386.4h-5.963a.594.594,0,1,1,0-1.187h5.963a.594.594,0,1,1,0,1.187Z",
    transform: "translate(-217.193 -385.213)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M230.408,416.425H217.787a.594.594,0,1,1,0-1.187h12.622a.594.594,0,0,1,0,1.187Z",
    transform: "translate(-217.193 -415.238)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.703 5.389)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.451)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M231.476,71.33h-8.416a.594.594,0,1,1,0-1.187h8.416a.594.594,0,1,1,0,1.187Z",
    transform: "translate(-222.467 -70.143)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.4,71.33h-2.276a.594.594,0,1,1,0-1.187H167.4a.594.594,0,1,1,0,1.187Z",
    transform: "translate(-164.533 -70.143)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.02a911bb2b7462c07c1cc0d59338de61.svg";
export { ForwardRef as ReactComponent };